import React, { useEffect } from 'react'
import { Box, Button, FormControl, InputLabel, LinearProgress, MenuItem, Modal, Select, Stack, TextField, Typography } from '@mui/material';
import { Autocomplete } from "@mui/lab";
import RoleService from "../../../../services/RoleService";
import Request from '../../../../services/Request.js';
import UserService from "../../../../services/UserService";


const AddUserModal = ({ open, onClose, onSave }) => {

    const [loading, setLoading] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [roles, setRoles] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('');
    const [selectedOption, setSelectedOption] = React.useState(null);
    const [selectedRole, setSelectedRole] = React.useState(null);
    const [allData, setAllData] = React.useState([]);


    useEffect(() => {
        const fetchRoles = async () => {
            try {
                setLoading(true);
                const response = await RoleService.getRoles();
                setRoles(response);
            } catch (error) {
                console.error('Error fetching roles:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRoles();
    }, []);

    const handleRoleChange = (event) => {
        const selectedRoleId = event.target.value;
        const role = roles.find((role) => role.id === selectedRoleId);
        setSelectedRole(role);
    };

    const handleSearch = async (value, page = 1) => {
        try {
            setLoading(true);
            const response = await Request.get('/api/users', {
                keyword: value,
                limit: 10,
            });
            setAllData(response.data);
            setOptions(response.data.data);
            return true;
        } catch (error) {
            console.error('Error fetching users:', error);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const handleSave = () => {
        if (selectedOption && selectedRole) {
            const userData = {
                user: selectedOption,
                role: selectedRole,
            };
            onSave(userData);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ margin: 'auto', mt: 5, width: 400, bgcolor: 'background.paper', p: 3 }}>
                <div className="material-card">
                    <div className="material-card-header">
                        <div className="row">
                            <div className="col-xs-12">
                                <h3>Add new User</h3>
                            </div>
                        </div>
                    </div>
                    <div className="material-form">
                        <Autocomplete
                            fullWidth
                            options={roles}
                            loading={loading}
                            filterOptions={(x) => x}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, value) => setSelectedRole(value)}
                            onInputChange={(event, value) => {
                                setSearchValue(value);
                                handleSearch(value).then(r => !r);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Role" variant="outlined" sx={{ mb: 2 }}>
                                    <LinearProgress sx={{ mb: 2 }} />
                                </TextField>
                            )}
                            renderOption={(props, option) => (
                                <li {...props}>
                                    {option.name}
                                </li>
                            )}
                        />
                        <Autocomplete
                            fullWidth
                            options={allData}
                            loading={loading}
                            filterOptions={(x) => x}
                            getOptionLabel={(option) => option.username}
                            onChange={(event, value) => setSelectedOption(value)}
                            onInputChange={(event, value) => {
                                setSearchValue(value);
                                handleSearch(value).then(r => !r);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Email" variant="outlined" sx={{ mb: 2 }}>
                                    <LinearProgress sx={{ mb: 2 }} />
                                </TextField>
                            )}
                            renderOption={(props, option) => (
                                <li {...props}>
                                    {option.username}
                                </li>
                            )}
                        />
                        <Stack spacing={2} direction="row">
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                            <Button variant="outlined" onClick={onClose}>Cancel</Button>
                        </Stack>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}

export default AddUserModal
